import React, { useCallback, useState } from 'react';
import { styled } from '@customink/pigment-react/lib/themeCustomink';
import { Box, Button, ExitIcon, Stack, Typography } from '@customink/pigment-react';
import { useAuth } from '~/contexts/Auth/AuthContext';
import { MenuItem } from './MenuItem';
import NavigationModal from './NavigationModal';

interface MobileNavigationProps {
    menu: Array<MenuItem>;
}

const MobileNavigationWrapper = styled(Stack)(({ theme }) => ({
    paddingRight: theme.spacing(2),
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
}));

const NavigationToggler = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    ':before': {
        content: '"Viewing:"',
        color: theme.palette.grey[400],
        paddingRight: theme.spacing(1),
    },
    ':after': {
        content: '"▼"',
        fontSize: 6,
        height: 12,
        marginLeft: theme.spacing(1),
        position: 'relative',
        top: -2,
    },
}));

const ButtonTypography = styled(Typography)(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: 4,
}));

const MobileNavigation: React.FC<MobileNavigationProps> = ({ menu }) => {
    const [dialogOpen, setDialogOpen] = useState<boolean>(false);
    const { logout } = useAuth();

    const showDialog = useCallback(() => {
        setDialogOpen(true);
    }, []);

    const hideDialog = useCallback(() => {
        setDialogOpen(false);
    }, []);

    return (
        <MobileNavigationWrapper>
            <Typography variant="captionRegular">
                <NavigationToggler onClick={showDialog}>{menu.find((m) => m.selected)?.label}</NavigationToggler>
            </Typography>
            <Button variant="link" onClick={logout} data-action="logout">
                <ButtonTypography variant="bodyShort1">
                    <ExitIcon fontSize="inherit" /> Logout
                </ButtonTypography>
            </Button>
            <NavigationModal menu={menu} open={dialogOpen} onClose={hideDialog} />
        </MobileNavigationWrapper>
    );
};

export default MobileNavigation;
